"use client";

import {createContext, useContext} from "react";
import type {ReviewEditorPage} from "@/services/wingman/mutation-proposal";

/** A proposal under review on the page that edits its target, such as a phone script or an Action. */
export type MutationProposalReview = ReviewEditorPage & {
   proposalId: string;
   conversationId: string;
   host: HTMLDivElement | null;
   setHost: (node: HTMLDivElement | null) => void;
   hasReview: boolean;
   setHasReview: (value: boolean) => void;
   /** True until the reviewed proposal reaches an outcome; an editor holds its own saves meanwhile. */
   decisionPending: boolean;
   setDecisionPending: (value: boolean) => void;
   finish: () => void;
};

export const MutationProposalReviewContext = createContext<MutationProposalReview | null>(null);

export const useMutationProposalReview = () => useContext(MutationProposalReviewContext);

/** The conversation shown beside a reviewed page when the dock cannot hold it. */
export const MutationProposalSideConversationContext = createContext<string | null>(null);

/** The side conversation of a reviewed page, which covers the page below md. */
export type ReviewConversation = {
   /** Shows a closed conversation; null while it is open. */
   open: (() => void) | null;
   /** The conversation shows at md and up, so `open` is only needed below md. */
   openBelowMdOnly: boolean;
   /** Uncovers the page below md, leaving the conversation beside it on wider screens. */
   showPage: () => void;
};

export const ReviewConversationContext = createContext<ReviewConversation | null>(null);
